import { createFileRoute } from "@tanstack/react-router";
import { requireReachableRoute } from "@/lib/offline/routeGuard";

// Section layout guard: staff is online-only by design (admin,
// security-sensitive). Covers every child route via ancestor stance resolution.
export const Route = createFileRoute("/_auth/app/_app/org/$orgId/staff")({
	staticData: { offline: "online-only" },
	beforeLoad: () => requireReachableRoute("online-only"),
});
